import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "text",
  data: function data() {
    return {
      check: "",
      date: new Date(),
      left: 0
    };
  },
  computed: {
    scroll: function scroll() {
      return this.vaildData(this.option.scroll, false);
    },
    linkHref: function linkHref() {
      return this.option.linkHref || "#";
    },
    linkTarget: function linkTarget() {
      return this.option.linkTarget || "_self";
    },
    step: function step() {
      return this.option.step || 5;
    },
    speed: function speed() {
      return this.option.speed || 100;
    },
    lineHeight: function lineHeight() {
      return this.option.lineHeight || 40;
    },
    fontSize: function fontSize() {
      return this.option.fontSize || 30;
    },
    fontFamily: function fontFamily() {
      return this.option.fontFamily;
    },
    split: function split() {
      return this.option.split;
    },
    textWidth: function textWidth() {
      var textLen = (this.dataChart.value || '').length;
      return textLen * this.fontSize;
    },
    styleName: function styleName() {
      return Object.assign({
        width: this.scroll ? this.setPx(this.textWidth) : 'auto',
        transform: "translateX(" + this.left + "px)",
        textAlign: this.option.textAlign,
        letterSpacing: this.setPx(this.split),
        textIndent: this.setPx(this.split),
        backgroundColor: this.option.backgroundColor,
        fontWeight: this.option.fontWeight || "normal",
        fontFamily: this.fontFamily,
        fontSize: this.fontSize + "px",
        lineHeight: this.lineHeight + "px",
        color: this.option.color || "#333"
      }, this.styles);
    }
  },
  watch: {
    scroll: function scroll() {
      this.move();
    },
    speed: function speed() {
      this.move();
    }
  },
  created: function created() {
    var _this = this;

    setInterval(function () {
      _this.date = new Date();
    }, 1000);
  },
  mounted: function mounted() {
    this.move();
  },
  methods: {
    handleClick: function handleClick() {
      this.updateClick({
        value: this.dataChart.value
      });
      this.clickFormatter && this.clickFormatter({
        data: this.dataChart
      }, this.getItemRefs());
    },
    move: function move() {
      var _this2 = this;

      clearInterval(this.check);

      if (this.scroll) {
        this.check = setInterval(function () {
          if (_this2.left < -_this2.textWidth) {
            _this2.left = _this2.width;
          }

          _this2.left = _this2.left - _this2.step;
        }, this.speed);
      } else {
        this.left = 0;
      }
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});